import { salesOrdersTypes } from './actionTypes';

export const getSalesOrdersList = (payload: any) => ({
  type: salesOrdersTypes.GET_ORDERS_DEFINITIONS,
  payload,
});

export const getSaleOrdersListSuccess = (payload: any) => ({
  type: salesOrdersTypes.GET_SALE_ORDERS_SUCCESS,
  payload,
});

export const getSaleOrdersListFail = (error: any) => ({
  type: salesOrdersTypes.GET_SALE_ORDERS_FAIL,
  payload: error,
});

export const getMilestoneConfigSO = ()=>{
  return{
    type: salesOrdersTypes.GET_MILESTONESCONFIG_SO,
  }
}

export const getMilestoneConfigSOSuccess = (payload:any)=>{
  return{
    type: salesOrdersTypes.GET_MILESTONESCONFIG_SO_SUCCESSS,
    payload,
  }
}

export const getMilestoneConfigSOFail = (payload:any)=>{
  return{
    type: salesOrdersTypes.GET_MILESTONESCONFIG_SO_FAIL,
    payload,
  }
}
